export default "__VITE_ASSET__CBexfRbi__"